import ArchiveTable from "./ArchiveTable";

const Archive = () => {
  return (
    <div className="pt-5 pb-10 w-full h-full lg:scrollbar-thin lg:scrollbar-thumb-gray-500 lg:overflow-y-scroll lg:scrollbar-thumb-rounded-full lg:scrollbar-track-rounded-full">
      <h1 className="pl-8 pb-2 text-3xl font-bold border-b-2">Archives</h1>

      <div className="pl-8 mt-8">
        <ArchiveTable />
      </div>

      <div className="min-h-[5rem] md:hidden"></div>
    </div>
  );
};

export default Archive;
